import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { EDUCATION_LEVELS } from '#/utils/constants/general/educationLevels';

export function educationFacet(i18n: I18nFn) {
  return {
    id: 'educationFacet',
    name: 'education',
    get title() {
      return i18n('Education Level');
    },
    type: 'array',
    options: Object.keys(EDUCATION_LEVELS(i18n)),
    optionTitles: EDUCATION_LEVELS(i18n),
    sort: false,
  } as const satisfies SearchFacetData;
}
